import { useQuery } from '@tanstack/react-query'
import { formatMoney } from '@johnsaks/core'
import { EmptyState } from '@/components/empty-state'
import { api } from '@/lib/api'

type SalesRow = {
  productId: string
  name: string
  sku: string
  unitsSold: number
  orderLines: number
  revenueCents: number
}

export function Rapports() {
  const sales = useQuery({
    queryKey: ['admin-reports-sales'],
    queryFn: () => api<{ byProduct: SalesRow[] }>('/admin/reports/sales'),
  })

  const rows = sales.data?.byProduct ?? []

  return (
    <div className="flex flex-col gap-5">
      {sales.isLoading ? (
        <p className="text-second-admin">Chargement…</p>
      ) : rows.length === 0 ? (
        <EmptyState title="Pas encore de ventes" body="Le rapport se remplira avec les commandes." />
      ) : (
        <section className="carte-admin overflow-x-auto">
          <div className="border-b border-bordure-admin px-4 py-3">
            <h2 className="text-base">Ventes par produit</h2>
          </div>
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-bordure-admin">
                {['SKU', 'Produit', 'Unités', 'Lignes', 'CA'].map((h) => (
                  <th key={h} className="px-4 py-2.5">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.productId} className="border-b border-bordure-admin last:border-0">
                  <td className="px-4 py-2.5 text-second-admin">{r.sku}</td>
                  <td className="px-4 py-2.5 font-medium">{r.name}</td>
                  <td className="px-4 py-2.5 tabular-nums">{r.unitsSold}</td>
                  <td className="px-4 py-2.5 tabular-nums">{r.orderLines}</td>
                  <td className="px-4 py-2.5 tabular-nums">{formatMoney(r.revenueCents)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}
    </div>
  )
}
